import React, { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";
import { useIp } from "./IpContext";

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

// Module-level singleton so only one socket connection is ever created,
// even if SocketProvider re-renders. Without this, each render would open
// a new connection to the server.
let globalSocket = null;

export const SocketProvider = ({ children }) => {
  const { ipAddress, port } = useIp();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Wait until the server IP has been fetched before connecting
    if (!ipAddress) return;

    if (!globalSocket) {
      globalSocket = io(`http://${ipAddress}:${port}`, {
        withCredentials: true,
      });
      setSocket(globalSocket);
    }

    return () => {
      if (globalSocket) {
        globalSocket.disconnect();
        globalSocket = null;
      }
    };
  }, [ipAddress, port]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};
